import $ from 'jquery';
import SimpleBar from 'simplebar';
import StickySidebar from 'sticky-sidebar/dist/sticky-sidebar';
import Utils from '@core/base/scripts/utils/utils';

export default class BaseStickySidebar {
  constructor(container) {
    this.container = container;
    this.sidebar = null;
    this.simpleBar = null;
    this.autoHideBar=true;
    this.isInit = false;
  }

  init() {
    this.$wrapper = $('.base-sticky-sidebar__wrapper');
    this.$content = $('.base-sticky-sidebar__content', this.$wrapper);

    if (!Utils.isTablet) {
      this.sidebar = new StickySidebar('.module-sticky-bar', this.shareSidebarOptions);
      this.simpleBar = new SimpleBar(this.$wrapper[0], {
        autoHide: this.autoHideBar
      });
    }
    this.isInit = true;
  }


  destroy() {
    if (this.sidebar) {
      this.sidebar.destroy();
    }
    if (this.simpleBar) {
      this.$content = $('.base-sticky-sidebar__content', this.$wrapper);
      $('.simplebar-wrapper', this.$wrapper).remove();
      $('.simplebar-track', this.$wrapper).remove();
      this.$wrapper.append(this.$content);
      this.$wrapper.removeAttr('data-simplebar style');
      this.simpleBar.unMount();
      this.simpleBar = null;
    }
    this.$wrapper = null;
    this.$content = null;
    this.isInit = false;
  }

  get shareSidebarOptions() {
    return {
      topSpacing: this.topSacing,
      bottomSpacing: this.bottomSpacing,
      containerSelector: '.base-sticky-sidebar',
      innerWrapperSelector: '.base-sticky-sidebar__wrapper'
    };
  }


  onResize() {
    if (this.isInit) {
      this.destroy();
    }
    this.init(true);
  }

  get topSacing() {
    return Utils.headerHeight() + 20;
  }

  get bottomSpacing() {
    return 0;
  }
}
